import { connect } from 'react-redux';

import WeekDay from '~/Components/Pages/Calendar/WeekView/Day';
import { formatEvents } from '~/Context/Event';
import { filterEventsByCalendarDisplay } from '~/Redux/Modules/Events/selectors';

//Duplicate of Containers/Pages/Calendar/MonthView/Day.js
//TODO Can be reused, need to confirm final path (Global vs. Pages) with Josh
const mapStateToProps = ({ Events, CalendarAccounts }) => {
  const calendarDisplayOptions = {
    includeMonthView: true,
    includeWeekView: false,
    includeDayView: true,
  };
  const calendarMap = CalendarAccounts.calendarMap;
  const filteredEvents = filterEventsByCalendarDisplay(
    Events.formattedData,
    calendarDisplayOptions,
    calendarMap
  );
  return {
    events: filteredEvents,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(WeekDay);
